import type { SVGProps } from 'react';

export const Download = (props: SVGProps<SVGSVGElement>) => (
    <svg width='24' height='24' viewBox='0 0 24 24' fill='currentColor' xmlns='http://www.w3.org/2000/svg' {...props}>
        <path d='M20 18v1.93a.58.58 0 0 1-.29.07H4.29a.58.58 0 0 1-.29-.07V18H2v2a2.13 2.13 0 0 0 2.29 2h15.42A2.13 2.13 0 0 0 22 20v-2h-2ZM12 17.83a2 2 0 0 0 1.41-.59l5.42-5.41-1.42-1.42L13 14.83V2h-2v12.83l-4.41-4.42-1.42 1.42 5.42 5.41a2 2 0 0 0 1.41.59Z' />
    </svg>
);
